<core-modal-window header="Nutzungsbedingungen" size="lg" [modalRef]="modalRef" [showClose]="settingsStore.tosAccepted()">
  <div slot="body" class="p-md">
    <app-markdown [markdown]="md"></app-markdown>
  </div>
  @if (!settingsStore.tosAccepted()) {
    <div slot="footer" class="p-sm flex justify-end gap-sm items-center">
      <a href="https://svs.at" class="no-underline">
        <core-button btnStyle="secondary">Chatbot verlassen</core-button>
      </a>
      <core-button (triggered)="acceptTos()">Als gelesen markieren</core-button>
    </div>
  }
</core-modal-window>
